import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PaymentUrlRequestBody, PaymentUrlResponse } from "./types";

export class PaymentUrlAPI extends BaseAPI<
  PaymentUrlRequestBody,
  PaymentUrlResponse
> {
  protected route = ApiRoutes.payment.url;
  protected method = RequestMethod.POST;
}
